import "./App.css";
import { Leva } from "leva";
import { useState, useEffect, Suspense } from "react";
import gsap from "gsap";
import { useLocation } from "wouter";
import { TextShader } from "./components/TextShader";
import { BentoGrid } from "./components/BentoGrid";
import { SocialLinks } from "./components/SocialLinks";
import { NavButtons } from "./components/NavButtons";
import { SelectShader } from "./components/SelectShader";
import { Navbar } from "./components/Navbar";

function App() {
  const [showAbout, setShowAbout] = useState("");
  const [showWork, setShowWork] = useState("");
  const [showSkills, setShowSkills] = useState("");
  const [location, setLocation] = useLocation();
  const [fragShader, setFragShader] = useState(1);

  const LoadingScreen = () => {
    return (
      counter >= 57 && (
        <div className="flex absolute top-0 left-0 w-screen md:h-screen h-[100dvh] z-10 backdrop-blur-xl items-center justify-center">
          <p className="text-[120px] text-[#ffffff] entry-text">
            {"<"}WELCOME{" />"}
          </p>
        </div>
      )
    );
  };

  useEffect(() => {
    showSkills === "show" &&
      gsap.fromTo(
        ".show-skills",
        { display: "none", scale: 0 },
        { display: "flex", scale: 1, duration: 0.6, ease: "back.out" }
      );
    showSkills === "hide" &&
      gsap.to(
        ".show-skills",
        { scale: 1, display: "flex" },
        { scale: 0, display: "none" }
      );
  }, [showSkills]);

  return (
    <>
      <Leva
        collapsed={false}
        flat={true}
        hidden
        theme={{
          sizes: {
            titleBarHeight: "28px",
          },
          fontSizes: {
            root: "10px",
          },
        }}
      />
      <main className="relative font-sans w-screen md:h-screen h-[100dvh] flex items-center justify-center">
        <BentoGrid
          showAbout={showAbout}
          setShowAbout={setShowAbout}
          setShowSkills={setShowSkills}
          setShowWork={setShowWork}
        />
        {<TextShader fragShader={fragShader} />}
        {/* <LoadingScreen /> */}
        <a href="mailto:shreeramganeshan@gmail.com" className="hidden lg:block lg:absolute top-[30px] lg:top-[40px] left-[20px] lg:left-[40px] font-[raleway] text-[12px] lg:text-[18px] font-thin">
          shreeramganeshan@gmail.com
        </a>
        <div className="hidden lg:block lg:absolute bottom-[30px] w-fit h-fit lg:bottom-[40px] right-[20px] lg:left-[40px] font-[raleway] text-[12px] lg:text-[18px] font-thin">
          Mumbai, India
        </div>
        {/* <NavButtons
          setShowAbout={setShowAbout}
          setShowWork={setShowWork}
          setShowSkills={setShowSkills}
        /> */}
        <SocialLinks />
        <a
          onClick={() => setShowAbout("show")}
          className="absolute top-8 lg:top-12 lg:left-1/3 flex items-center justify-center text-[12px] lg:text-[18px] font-[raleway]  h-[30px] lg:h-[40px] w-20 md:w-40 overflow-hidden border-[0.5px] border-white font-extralight bg-transparent text-white shadow-2xl transition-all before:absolute before:left-0 before:top-0 before:h-full before:w-0 before:duration-500 after:absolute after:right-0 after:top-0 after:h-full after:w-0 after:duration-500 hover:shadow-white hover:before:w-2/4 hover:before:bg-white hover:after:w-2/4 hover:after:bg-white hover:text-black cursor-pointer"
        >
          <p className="relative z-10">ABOUT</p>
        </a>
        
        <SelectShader setFragShader={setFragShader} />
      </main>
    </>
  );
}

export default App;
